
import MajorTable from "../components/MajorTable.vue";
import Section from "../components/Section.vue";
import { mapState } from "vuex";

export default {
  props: ["title"],
  computed: {
    ...mapState("Major", ["listGroupByNameGroup", "majorLoading"]),
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      value1: "",
      majorSearch: "",
      filterOptions: [
        // { label: "Điểm chuẩn", id: "1" },
        { label: "Ngành", id: "2" },
      ],
    };
  },
  components: { Section, MajorTable },
  mounted() {
    this.getListGroupMajors(this.title);
  },
  methods: {
    handleChange(value) {
      console.log(`selected ${value}`);
    },
    async getListGroupMajors(title) {
      this.$store.dispatch("Major/getListGroupByNameGroup", title);
    },
    searchMajor() {
      this.$store.dispatch("Major/getListGroupBySearchInput", {
        search: this.majorSearch,
        group: this.title,
      });
    },
  },
};
